import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ['input', 'left', 'right']
  static values = {
    className: String
  }

  connect(){
    this.inputTarget.value === "true" ? this.selectRight() : this.selectLeft()
  }

  selectRight(){
    this.inputTarget.value = "true"
    this.unselect(this.leftTarget)
    this.select(this.rightTarget)
  }

  selectLeft(){
    this.inputTarget.value = "false"
    this.select(this.leftTarget)
    this.unselect(this.rightTarget)
  }

  select(target){
    target.classList.remove("btn-outline")
  }

  unselect(target) {
    target.classList.add("btn-outline")
  }
}
